import z from 'zod';

import { NotificationMethodType } from '../notification-settings/notification-settings.types';

export enum NotificationCategoryType {
  CHAT = 'chat',
  VESSEL = 'vessel',
  ACTIVITY = 'activity',
  USER = 'user',
}

export interface NotificationCategoryDto {
  user_id: string;
  category: NotificationCategoryType;
  type: NotificationMethodType[];
}

export interface NotificationCategory {
  userId: string;
  category: NotificationCategoryType;
  type: NotificationMethodType[];
}

export const createNotificationCategorySchema = z.object({
  category: z.nativeEnum(NotificationCategoryType),
  type: z
    .array(z.nativeEnum(NotificationMethodType))
    .min(1, 'Please choose at least one way to be notified.'),
});

export type CreateNotificationCategoryFormValues = z.infer<typeof createNotificationCategorySchema>;

export const updateNotificationCategorySchema = z.object({
  category: z.nativeEnum(NotificationCategoryType),
  type: z
    .array(z.nativeEnum(NotificationMethodType))
    .min(1, 'Please choose at least one way to be notified.'),
});

export type UpdateNotificationCategoryFormValues = z.infer<typeof updateNotificationCategorySchema>;
